import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Form, message, Select } from "antd";
import dataService from "../networks/api/service/dataService";
import DynamicExcelUpload from "../components/DynamicExcelUpload";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
import CustomTable from "../components/TableComponent/CustomTable";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
import UploadButton from "../components/TableComponent/ButtonComponent/UploadButton";
import DownloadButton from "../components/TableComponent/ButtonComponent/DownloadButton";
const AssemblyList = () => {
  const [data, setData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [adminOptions, setAdminOptions] = useState([]);
  const [constituencyOption, setconstituencyOption] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false);
  const [editingAssemblyId, setEditingAssemblyId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  // Columns for the assembly table
  const columns = [
    {
      title: "Assembly Name",
      dataIndex: "assemblyName",
      key: "assemblyName",
    },
    {
      title: "Admin Name",
      dataIndex: "adminName",
      key: "adminName",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];

  // Show modal
  const showModal = () => {
    setIsEditMode(false);
    setIsModalVisible(true);
  };

  const getExcelData = async (formData) => {
    console.log(formData, "getExcelData");
    try {
      const res = await dataService.uploadBulkAssembly(formData);
      if (res.code === 200) {
        getAssembly();
      }
    } catch (e) { }
  };

  // Edit button handler
  const handleEdit = (record) => {
    setIsEditMode(true);
    setEditingAssemblyId(record._id);
    form.setFieldsValue({
      assemblyName: record.assemblyName,
      adminId: record.adminId,
    });
    setIsModalVisible(true);
  };

  const saveAssembly = async (payload) => {
    try {
      let res;
      if (isEditMode && editingAssemblyId) {
        res = await dataService.editAssembly(editingAssemblyId, payload);
      } else {
        res = await dataService.addAssembly(payload);
      }
      if (res.code === 200) {
        message.success(
          isEditMode
            ? "Assembly updated successfully"
            : "Assembly added successfully"
        );
        getAssembly(); // Refresh assembly list
        setIsModalVisible(false);
        form.resetFields();
      }
    } catch (e) {
      message.error(
        isEditMode ? "Failed to update assembly" : "Failed to add assembly"
      );
      console.error("Error:", e);
    }
  };

  // Handle modal submit
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          assemblyName: values.assemblyName,
          adminId: values.adminId,
          constituency: values.constituencyId,
        };
        saveAssembly(payload);
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };

  // Handle modal cancel
  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const getAdmin = async () => {
    try {
      const res = await dataService.getAdminForPanchayat("ASSEMBLY");
      if (res.code === 200) {
        setAdminOptions(res.data);
      }
    } catch (e) {
      console.error("Error fetching admin options:", e);
    }
  };

  // Fetch assembly data
  const getAssembly = async () => {
    try {
      const res = await dataService.getAllAssembly();
      if (res.code === 200) {
        setData(res.data);
        setFilteredData(res.data);
      }
    } catch (e) {
      console.error("Error fetching assembly data:", e);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = data.filter((item) =>
      item.assemblyName.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const downloadSampleFile = () => {
    const worksheet = XLSX.utils.json_to_sheet([
      { "Sl NO": "", CONSTITUENCY: "", ASSEMBLY: "" },
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Assembly_Sample");
    XLSX.writeFile(workbook, "Assembly_Sample.xlsx");
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) {
        setconstituencyOption(res.data);
      }
    } catch (e) {
      console.error("Error fetching assembly data:", e);
    }
  };

  useEffect(() => {
    getAssembly();
    getAdmin();
    getConstituency();
  }, []);

  return (
    <div>
      <h2>Assembly List</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // marginBottom: 10,
        }}
      >
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginBottom: 20 }}
        >
          Add Assembly
        </Button>
        <Input.Search
          placeholder="Search by Assembly Name"
          onChange={handleSearch}
          style={{ width: 200 }}
        />
      </div>

      {/* Table to show Assembly List */}
      <CustomTable
        dataSource={filteredData}
        columns={columns}
        rowKey={(record) => record._id}
        bordered
        pagination={{ position: ["bottomCenter"], pageSize: 5 }}
        size="middle"
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
        }}
        scroll={{ x: 800 }}
      />

      <div style={{ marginTop: 20 }}>
        <h3>Bulk Upload</h3>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <DownloadButton onClick={downloadSampleFile}>
            Download Sample File
          </DownloadButton>
        </div>
        <DynamicExcelUpload getExcelData={getExcelData} />
      </div>

      {/* Modal for adding or editing Assembly */}
      <Modal
        title={isEditMode ? "Edit Assembly" : "Add Assembly"}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={isEditMode ? "Update" : "Save"}
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Assembly Name"
            name="assemblyName"
            rules={[
              { required: true, message: "Please enter Assembly Name" },
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}
          >
            <Input placeholder="Enter Assembly Name" />
          </Form.Item>

          <Form.Item
            label="Admin"
            name="adminId"
            rules={[{ required: true, message: "Please select an Admin" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{ border: "1px solid grey", borderRadius: 5 }}
              placeholder="Select Admin"
            >
              {adminOptions.map((admin) => (
                <Select.Option key={admin._id} value={admin._id}>
                  {admin.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Constituency"
            name="constituencyId"
            rules={[{ required: true, message: "Please select an Admin" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Constituency"
            >
              {constituencyOption.map((admin) => (
                <Select.Option key={admin._id} value={admin._id}>
                  {admin.constituencyName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AssemblyList;
